import cn from 'classnames'
import { translatePaymentMethodName } from 'mmfintech-commons'

import { MethodImage } from './MethodImage'
import { MethodButtonStyled } from './MethodButton.styled'

type MethodButtonProps = {
  name: string
  selected: boolean
  setSelected: (name: string) => void
}

export const MethodButton = ({ name, selected, setSelected }: MethodButtonProps) => (
  <MethodButtonStyled className={cn({ selected })} onClick={() => setSelected(name)} data-test='button-payment-method'>
    <MethodImage method={name} className={cn({ selected })} />
    {translatePaymentMethodName(name)}
  </MethodButtonStyled>
)
